import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FuncionarioCargoProducao } from '../../../models/cadastro.model';
import { ErrorModel } from '../../../models/error.model';
import { CadastroService } from '../../../services/cadastro.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-funcionario-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './funcionario-modal.html',
  styleUrl: './funcionario-modal.css'
})
export class FuncionarioModal implements OnInit, OnChanges {
  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<FuncionarioCargoProducao | undefined>();

  private cadastroService = inject(CadastroService);
  private toastr = inject(ToastrService);

  funcionariosDisponiveis: FuncionarioCargoProducao[] = [];
  funcionariosFiltrados: FuncionarioCargoProducao[] = [];
  selecionado: FuncionarioCargoProducao | null = null;
  busca = '';

  ngOnInit(): void {
    this.carregarFuncionarios();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']?.currentValue === true) {
      this.selecionado = null;
      this.busca = '';
      this.filtrar();
    }
  }

  private carregarFuncionarios(): void {
    this.cadastroService.getFuncionariosCargos().subscribe({
      next: (data) => {
        this.funcionariosDisponiveis = data;
        this.funcionariosFiltrados = data;
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar funcionários.');
      }
    });
  }

  filtrar(): void {
    const termo = this.busca.toLowerCase().trim();
    this.funcionariosFiltrados = !termo
      ? this.funcionariosDisponiveis
      : this.funcionariosDisponiveis.filter(f =>
          f.nome.toLowerCase().includes(termo) || f.cargo.toLowerCase().includes(termo)
        );
  }

  selecionar(f: FuncionarioCargoProducao): void {
    this.selecionado = f;
  }

  resolverIdFuncionario(f: FuncionarioCargoProducao): number | undefined {
    return f.idFuncionario ?? f.id ?? f.codigo;
  }

  confirmar(): void {
    if (!this.selecionado) {
      this.toastr.warning('Selecione um funcionário.');
      return;
    }
    const idFuncionario = this.resolverIdFuncionario(this.selecionado);
    if (idFuncionario == null) {
      this.toastr.error('Funcionário selecionado sem identificador válido.');
      return;
    }
    this.closeModal.emit({ ...this.selecionado, idFuncionario });
  }

  onClose(): void {
    this.closeModal.emit(undefined);
  }
}
